export const COMPANY = `
query company(
  $tenant_id: Int!,
  $id: Int! 
){
  company(
    tenant_id: $tenant_id
    id: $id
  ){
    __typename
    ... on Company{
      isOptimistic @client
      id
      name
      fantasy_name
      cuit
      phone
      website
      comments
      state
      state_date
      source
      industry
      income
      employees
      zoho_id
      active
      vistage20_id
      province_id
      city
      company_type
      its
      uts
      dts
      company_state {
        id
        name
        restricted
        initial
      }
      company_source {
        id
        name
        vistage20_id
      }
      company_industry {
        id
        name
        active
        vistage20_id
      }
      income_company_incomeToincome {
        id
        name
        active
        vistage20_id
      }
    }
    ... on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const COMPANIES = `
query companies(
  $tenant_id: Int!,
  $searchText: String,
  $filter:  FilterCompanyInput,
  $orderBy:  CompanyOrderInput,
  $skip: Int,
  $take: Int
){
  companies(
    tenant_id: $tenant_id
    searchText: $searchText
    filter: $filter
    orderBy: $orderBy
    skip: $skip
    take: $take
  ){
    __typename
    ... on Company{
      isOptimistic @client
      id
      name
      fantasy_name
      cuit
      phone
      website
      comments
      state
      state_date
      source
      industry
      income
      employees
      zoho_id
      active
      vistage20_id
      province_id
      city
      company_type
      its
      uts
      dts
      company_state {
        id
        name
        restricted
        initial
      }
      company_source {
        id
        name
        vistage20_id
      }
      company_industry {
        id
        name
        active
        vistage20_id
      }
      income_company_incomeToincome {
        id
        name
        active
        vistage20_id
      }
    }
    ... on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const COMPANY_COUNT = `
query companyCount(
  $tenant_id: Int!,
  $searchText: String,
  $filter: FilterCompanyInput
){
  companyCount(
    tenant_id: $tenant_id
    searchText: $searchText
    filter: $filter
  ){
    __typename
    ... on Count{
      count
    }
    ... on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const COMPANY_STATES = `
query companyStates(
  $tenant_id: Int!
){
  companyStates(
    tenant_id: $tenant_id
  ){
    __typename
    ... on CompanyState{
      id
      name
      restricted
      initial
    }
    ... on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const COMPANY_SOURCES = `
query companySources(
  $tenant_id: Int!
){
  companySources(
    tenant_id: $tenant_id
  ){
    __typename
    ... on CompanySource{
      id
      name
      vistage20_id
    }
    ... on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const COMPANY_INDUSTRIES = `
query companyIndustries(
  $tenant_id: Int!
){
  companyIndustries(
    tenant_id: $tenant_id
  ){
    __typename
    ... on CompanyIndustry{
      id
      name
      active
      vistage20_id
    }
    ... on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;

export const INCOMES = `
query incomes(
  $tenant_id: Int!
){
  incomes(
    tenant_id: $tenant_id
  ){
    __typename
    ... on Income{
      id
      name
      active
      vistage20_id
    }
    ... on ResultError{
      status_code
      message
      message_translation_key
    }
  }
}
`;
